// This file contains searchable content from all pages
// Each item has: id, title, content, keywords, pageId, path

export const getSearchableContent = (t) => [
  // Home page
  {
    id: 'home-intro',
    title: t('home.title'),
    content: t('home.intro'),
    keywords: ['guide', 'droits', 'migrants', 'algérie', 'rights', 'حقوق', 'مهاجرين'],
    pageId: 'home',
    path: '/'
  },
  
  // Entry and Residence
  {
    id: 'entry-residence',
    title: t('entryResidence.title'),
    content: `${t('entryResidence.entryTitle')} ${t('entryResidence.residenceTitle')} ${t('entryResidence.circulationTitle')}`,
    keywords: ['entrée', 'séjour', 'visa', 'passeport', 'entry', 'residence', 'دخول', 'إقامة', 'تأشيرة'],
    pageId: 'entry-residence',
    path: '/entree-sejour'
  },
  {
    id: 'entry-deportation',
    title: t('entryResidence.deportationTitle'),
    content: t('entryResidence.deportationTitle'),
    keywords: ['éloignement', 'expulsion', 'reconduite', 'deportation', 'ترحيل', 'طرد'],
    pageId: 'entry-residence',
    path: '/entree-sejour'
  },
  
  // Health
  {
    id: 'health',
    title: t('health.title'),
    content: `${t('health.accessTitle')} ${t('health.confidentialityTitle')} ${t('health.womenChildrenTitle')}`,
    keywords: ['santé', 'soins', 'hôpital', 'urgence', 'health', 'hospital', 'صحة', 'مستشفى', 'طوارئ'],
    pageId: 'health',
    path: '/sante'
  },
  
  // Civil Status and Family
  {
    id: 'civil-family',
    title: t('civilFamily.title'),
    content: `${t('civilFamily.birthTitle')} ${t('civilFamily.marriageTitle')} ${t('civilFamily.filiationTitle')}`,
    keywords: ['naissance', 'mariage', 'état civil', 'famille', 'birth', 'marriage', 'ميلاد', 'زواج', 'أسرة'],
    pageId: 'civil-family',
    path: '/etat-civil-famille'
  },
  
  // Work and Housing
  {
    id: 'work-housing',
    title: t('workHousing.title'),
    content: `${t('workHousing.workTitle')} ${t('workHousing.housingTitle')}`,
    keywords: ['travail', 'salaire', 'exploitation', 'logement', 'work', 'salary', 'housing', 'عمل', 'أجر', 'سكن'],
    pageId: 'work-housing',
    path: '/travail-logement'
  },
  
  // Education and Justice
  {
    id: 'education-justice',
    title: t('educationJustice.title'),
    content: `${t('educationJustice.schoolTitle')} ${t('educationJustice.policeTitle')} ${t('educationJustice.judgeTitle')}`,
    keywords: ['école', 'éducation', 'police', 'commissariat', 'juge', 'justice', 'education', 'police', 'تعليم', 'شرطة', 'قاضي'],
    pageId: 'education-justice',
    path: '/education-justice'
  },
  
  // Detention
  {
    id: 'detention',
    title: t('detention.title'),
    content: t('detention.rightsTitle'),
    keywords: ['détention', 'prison', 'garde à vue', 'avocat', 'detention', 'prison', 'lawyer', 'احتجاز', 'سجن', 'محامي'],
    pageId: 'detention',
    path: '/detention'
  },
  
  // Documents
  {
    id: 'documents',
    title: t('documents.title'),
    content: t('documents.checklistTitle'),
    keywords: ['documents', 'passeport', 'visa', 'acte', 'certificat', 'passport', 'certificate', 'وثائق', 'جواز سفر'],
    pageId: 'documents',
    path: '/documents'
  },
  
  // Contact
  {
    id: 'contact',
    title: t('contact.title'),
    content: `${t('contact.fpraTitle')} ${t('contact.name')}`,
    keywords: ['contact', 'FPRA', 'aide', 'assistance', 'help', 'اتصال', 'مساعدة'],
    pageId: 'contact',
    path: '/contact'
  }
];
